import { Eye, EyeOff } from "lucide-react";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

interface RevealableInputProps {
  label: string;
  id: string;
  name: string;
  placeholder?: string;
  value: string;
  readOnly?: boolean;
  autoComplete?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const MASK = "•".repeat(24);

export const RevealableInput = ({
  label,
  id,
  name,
  placeholder,
  value,
  readOnly = false,
  autoComplete = "off",
  onChange,
}: RevealableInputProps) => {
  const [isRevealed, setIsRevealed] = useState(false);
  const showMask = readOnly && !isRevealed && value.length > 0;

  return (
    <div className="flex w-full flex-col gap-1">
      <label htmlFor={id} className="text-sm font-medium text-gray-500">
        {label}
      </label>
      <div className="relative flex w-full items-center">
        <Input
          autoComplete={autoComplete}
          type="text"
          name={name}
          id={id}
          placeholder={placeholder}
          value={showMask ? MASK : value}
          readOnly={readOnly}
          onChange={onChange}
          className={showMask ? "pr-10 font-mono" : "pr-10"}
        />
        {readOnly && value.length > 0 && (
          <Button
            type="button"
            onClick={() => setIsRevealed(prev => !prev)}
            className="absolute right-2 z-[1] rounded-full"
            variant="ghost"
            size="tinyIcon"
            aria-label={isRevealed ? `Hide ${label}` : `Show ${label}`}
          >
            {isRevealed ? (
              <EyeOff className="h-4 w-4 text-gray-500" />
            ) : (
              <Eye className="h-4 w-4 text-gray-500" />
            )}
          </Button>
        )}
      </div>
    </div>
  );
};
